import {
  Binary,
  Braces,
  Brackets,
  Calendar,
  CalendarClock,
  DecimalsArrowRight,
  Hash,
  Network,
  ToggleLeft,
  Type,
  type LucideIcon
} from 'lucide-react';

export const DATA_TYPES = [
  'string',
  'int',
  'long',
  'double',
  'bool',
  'timestamp',
  'date',
  'ip',
  'array',
  'struct'
] as const;

export type DataType = (typeof DATA_TYPES)[number];

export interface DataTypeInfo {
  icon: LucideIcon;
  label: string;
  /** One plain-language line, for tooltips and pickers. */
  description: string;
}

/** The glyph and wording for every field type the platform shows. */
export const DATA_TYPE_INFO: Readonly<Record<DataType, DataTypeInfo>> = {
  string: {
    icon: Type,
    label: 'String',
    description: 'Text, such as a host name or a path.'
  },
  int: {
    icon: Hash,
    label: 'Integer',
    description: 'A whole number, such as an event ID or a port.'
  },
  long: {
    icon: Binary,
    label: 'Long',
    description: 'A large whole number, such as a record number.'
  },
  double: {
    icon: DecimalsArrowRight,
    label: 'Double',
    description: 'A number with decimals, such as a score or a ratio.'
  },
  bool: { icon: ToggleLeft, label: 'Boolean', description: 'True or false.' },
  timestamp: {
    icon: CalendarClock,
    label: 'Timestamp',
    description: 'A date and time, to the millisecond.'
  },
  date: { icon: Calendar, label: 'Date', description: 'A calendar day, without a time.' },
  ip: { icon: Network, label: 'IP address', description: 'An IPv4 or IPv6 address.' },
  array: { icon: Brackets, label: 'Array', description: 'A list of values.' },
  struct: {
    icon: Braces,
    label: 'Struct',
    description: 'Named fields nested inside one value.'
  }
};
